import React, { FC, ReactElement, useState } from 'react';
import { TextField } from '@material-ui/core';
import { CartItem as CartItemInterface } from '../types';
import { useStyles } from './styles';

interface Props {
  product: CartItemInterface;
  updateCartPrice(quantity: number): void;
  showCartError(error: string): void;
}

const ProductQuantityField: FC<Props> = ({
  product,
  updateCartPrice,
  showCartError,
}: Props): ReactElement => {
  const classes = useStyles({ isCompact: false });
  const [quantity, setQuantity] = useState(product.total.quantity);
  const error = !!product?.availableStock && quantity > product.availableStock;
  const updateCart = () => {
    if (product.availableStock && quantity > product.availableStock) {
      showCartError(`Il n'y a que ${product.availableStock} de ${product.name} qui restent`);
      return;
    }

    updateCartPrice(quantity);
  };

  return (
    <TextField
      aria-label="product-quantity-field"
      classes={{ root: classes.input }}
      type="number"
      value={quantity}
      error={error}
      onChange={event => {
        if (+event.target.value >= 0) {
          setQuantity(+event.target.value);
        }
      }}
      onBlur={() => updateCart()}
      onKeyUp={event => {
        if (event.key === 'Enter') {
          updateCart();
        }
      }}
    />
  );
};

export default ProductQuantityField;
